import { lazy } from "solid-js";

import { MetaTitle } from "@/components/Base/MetaContainer";
// import { RouteTransitionWrapper } from "@/components/Base/Transition/Index";
import { H5SubLayout } from "@/layouts/h5/SubLayout";
import { isMobile } from "@/lib/isMobile";
import { UserKycAuthActionType } from "@/types/compontent/base/baseEnum.ts";
import { type RouteSectionProps } from "@solidjs/router";

const WalletPage = lazy(() => import("@/pages/walletLayout"));

const walletLayout = (props: RouteSectionProps) => {
  if (isMobile()) {
    return (
      // 过渡外层已经有了 效果重复 导致页面过渡行为不正常
      // <RouteTransitionWrapper>
      <>
        <MetaTitle.Wallet />
        <H5SubLayout {...props} />
      </>
      // </RouteTransitionWrapper>
    );
  } else {
    return (
      <WalletPage>
        <MetaTitle.Wallet />
        {props.children}
      </WalletPage>
    );
  }
};

export default () => {
  const BalancePage = lazy(() =>
    isMobile()
      ? import("@/pages/h5/wallet/balance")
      : import("@/pages/pc/wallet/balance"),
  );
  const BankcardPage = lazy(() =>
    isMobile()
      ? import("@/pages/h5/wallet/bankcard")
      : import("@/pages/pc/wallet/bankcard"),
  );
  const DepositPage = lazy(() =>
    import("@/pages/pc/wallet/deposit").then((mod) => ({
      default: mod.PcDepositPage,
    })),
  );
  const WithdrawPage = lazy(() =>
    import("@/pages/pc/wallet/withdraw").then((mod) => ({
      default: mod.PcWithdrawPage,
    })),
  );

  const BetshistoryPage = lazy(() =>
    isMobile()
      ? import("@/pages/h5/wallet/betHistory")
      : import("@/pages/pc/wallet/betHistory"),
  );
  const RolloverPage = lazy(
    () => isMobile() && import("@/components/Dialogs/BillFlow/BillFlowH5.tsx"),
  );

  const MybetPage = lazy(() =>
    isMobile()
      ? import("@/pages/h5/wallet/mybet")
      : import("@/pages/pc/wallet/mybet"),
  );
  const TransactionPage = lazy(() =>
    isMobile()
      ? import("@/pages/h5/wallet/transaction")
      : import("@/pages/pc/wallet/transaction"),
  );

  return {
    path: "wallet",
    component: walletLayout,
    info: {
      needLogin: true,
    },
    children: [
      {
        path: "balance",
        component: BalancePage,
        info: {
          needLogin: true,
        },
      },
      {
        path: "bankcard",
        component: BankcardPage,
        info: {
          needLogin: true,
        },
      },
      {
        path: "betshistory",
        component: BetshistoryPage,
        info: {
          needLogin: true,
        },
      },
      {
        path: "rollover",
        component: RolloverPage,
        info: {
          needLogin: true,
        },
      },
      {
        path: "mybet",
        component: MybetPage,
        info: {
          needLogin: true,
        },
      },
      {
        path: "transaction",
        component: TransactionPage,
        info: {
          needLogin: true,
        },
      },
      {
        path: "deposit",
        component: DepositPage,
        info: {
          needLogin: true,
          needKYC: true,
          KYCAction: UserKycAuthActionType.deposit,
        },
      },
      {
        path: "withdraw",
        component: WithdrawPage,
        info: {
          needLogin: true,
        },
      },
    ],
  };
};
